import React from 'react';
import { Building2, Settings, TrendingUp, Shield } from 'lucide-react';
import { approachContent } from '../data/mock';

const iconMap = {
  Building2,
  Settings,
  TrendingUp,
  Shield
};

const ApproachSection = () => {
  return (
    <section id="approach" className="section section-dark section-padding">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-4">
            {approachContent.title}
          </h2>
          <p 
            className="text-xl max-w-2xl mx-auto"
            style={{ color: 'var(--text-secondary)' }}
          >
            {approachContent.subtitle}
          </p>
        </div>

        {/* Pillars Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {approachContent.pillars.map((pillar, index) => {
            const IconComponent = iconMap[pillar.icon];
            return (
              <div 
                key={pillar.id}
                className="approach-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="icon-wrapper">
                  <IconComponent 
                    size={28} 
                    style={{ color: 'var(--accent-gold)' }}
                  />
                </div>
                <h3 
                  className="text-xl md:text-2xl font-semibold mb-3"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {pillar.title}
                </h3>
                <p 
                  className="text-base"
                  style={{ 
                    color: 'var(--text-secondary)',
                    lineHeight: '1.7'
                  }}
                >
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
